import React from 'react';

const MONTHS = ['янв', 'фев', 'мар', 'апр', 'май', 'июн',
                'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
const MONTHS_FULL = ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь',
                     'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'];

export const monthLabel = (iso) => {
  const [y, m] = iso.split('-');
  return `${MONTHS[Number(m) - 1]} ${y.slice(2)}`;
};

export const monthLabelFull = (iso) => {
  const [y, m] = iso.split('-');
  return `${MONTHS_FULL[Number(m) - 1]} ${y}`;
};

export const PERIOD_LABELS = { 30: '30 дней', 90: '90 дней', 365: 'Год' };
export const PREV_LABELS = { 30: 'к прошлым 30 дням', 90: 'к прошлым 90 дням', 365: 'к прошлому году' };

const fmt1 = (v) => new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 1 }).format(v);

// Доли с одним знаком после запятой — по-русски, через запятую, как в стрелках
export const fmtPct = (v) => `${fmt1(v)}%`;

/**
 * Изменение к прошлому периоду. kind='pp' — для долей в процентах (разница
 * в процентных пунктах, а не «рост на 12%» от 30% до 33.6% — так читают
 * неверно), kind='rel' — для количеств и денег (относительный рост).
 * Не показывается, если сравнивать не с чем или база нулевая.
 */
export const Delta = ({ current, previous, kind = 'rel', title }) => {
  if (previous === null || previous === undefined || current === null || current === undefined) return null;
  let value;
  if (kind === 'pp') {
    value = Math.round((current - previous) * 10) / 10;
  } else {
    if (!previous) return null;
    value = Math.round(((current - previous) / previous) * 1000) / 10;
  }
  const dir = value > 0 ? 'up' : value < 0 ? 'down' : 'flat';
  const arrow = dir === 'up' ? '▲' : dir === 'down' ? '▼' : '•';
  const unit = kind === 'pp' ? ' п.п.' : '%';
  return (
    <span className={`crma-delta crma-delta--${dir}`} title={title}>
      <span aria-hidden="true">{arrow}</span> {fmt1(Math.abs(value))}{unit}
    </span>
  );
};

export const SectionHead = ({ icon, title, sub, children }) => (
  <div className="crma-section-head">
    <div>
      <h2>{icon}{title}</h2>
      {sub && <p>{sub}</p>}
    </div>
    {children}
  </div>
);
